import { OutlookCompose } from '../../abstractions/Outlook';
import { setErrorNotification } from '../../abstractions/notifications';
import type { ComposeBase, OutlookEmailAddress, OutlookRecipientSet } from '../../abstractions/types';

export function getEmailAddressForBixelTransform(recipientSet: OutlookRecipientSet): OutlookEmailAddress {
  const { to, cc, bcc } = recipientSet;

  if (!recipientSet || (!to.length && !cc.length && !bcc.length)) {
    return { name: 'No Recipients', email: 'No Recipients' };
  }

  const totalRecipientCount = to.length + cc.length + bcc.length;
  if (totalRecipientCount > 1 || !to.length) {
    return {
      name: `${totalRecipientCount} Recipient${totalRecipientCount === 1 ? '' : 's'}`,
      email: 'Multiple Recipients',
    };
  }

  return to[0];
}

export function getEmailAddressList(recipientSet: OutlookRecipientSet): OutlookEmailAddress[] {
  const { to, cc, bcc } = recipientSet;

  if (to.length === 1 && !cc.length && !bcc.length) {
    return [to[0]];
  }

  return [
    ...to.map((_, idx) => ({ name: `to-${idx}`, email: `to-${idx}@hidden.email` })),
    ...cc.map((_, idx) => ({ name: `cc-${idx}`, email: `cc-${idx}@hidden.email` })),
    ...bcc.map((_, idx) => ({ name: `bcc-${idx}`, email: `bcc-${idx}@hidden.email` })),
  ];
}

export async function validateMessage(item: ComposeBase): Promise<boolean> {
  if (!item) {
    await setErrorNotification('Unable to load your message. Please try again in a minute.');
    return false;
  }

  const outlook = new OutlookCompose(item);
  if (!(await outlook.canTransform())) {
    await setErrorNotification('Tracking can only work in HTML emails.');
    return false;
  }

  const recipients = await outlook.getRecipients();
  if (!getEmailAddressList(recipients).length) {
    await setErrorNotification('An email address is needed to send your email.');
    return false;
  }

  return true;
}
